import $http from '@/libs/axios'

export default class InventoryUnitAPI {
  static async process(payload: any) {
    return (await $http.post('/inventory/units', payload)).data
  }

  static async delete(unitId: any) {
    return (await $http.delete(`/inventory/units/${unitId}`)).data
  }

  static async list() {
    return (await $http.get('/inventory/units')).data
  }
}
